import axios from 'axios'
import modulesDriversLoader from '../services/ModulesDriversLoader'

export default class EntityAddressManagementService {
    constructor() {
        modulesDriversLoader.load().then(({ getApiRoutes }) => {
            this.apiRotues = { ...getApiRoutes() }
        })
    }

    async create(entityId, payload = {}) {
        const response = await axios.post(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal_location/add`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data
    }

    async delete(entityId, addressId) {
        const response = await axios.delete(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal_location/remove/${addressId}`,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data.data
    }

    async edit(entityId, addressId, payload = {}) {
        const response = await axios.post(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal_location/edit/${addressId}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data
    }
}
